<template>
    <div class="fake-portfolio-list">
        <FakePortfolioCard />
        <FakePortfolioCard>
            <VJoyButton data-testid="portfolio-locked-signup-cta" :href="signupUrl" rel="nofollow">
                {{ t('profile.section.similar.signup.cta') }}
            </VJoyButton>
        </FakePortfolioCard>
    </div>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import {useRoute} from '@typed-router';
    import {useTranslation} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';
    import {anchorsPageProfile} from '~/config/anchors';
    import FakePortfolioCard from '~/features/portfolio/section/ui/FakePortfolioCard.vue';

    const {t} = useTranslation();
    const route = useRoute();

    const signupUrl = computed(() => {
        const currentPageUrl = `/profile${route.fullPath}#${anchorsPageProfile.portfolioSection}`;
        return `/who-are-you?redirect=${encodeURIComponent(currentPageUrl)}&pageSource=profile_page&componentSource=profile-portfolio-section`;
    });
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .fake-portfolio-list {
        display: grid;
        grid-template-columns: repeat(2, 304px);
        gap: var(--joy-core-spacing-4);
        justify-content: start;

        @include mq.screen_xs() {
            grid-template-columns: repeat(1, min(404px, 70vw));
            justify-content: center;
        }
    }
</style>
